import { ReactNode } from "react";
import { Box } from "@mui/system";
import { AppNavbar, AppSidebar } from "./components";
import { NAVIGATION_HEIGHT, APP_SIDEBAR_WIDTH } from "./consts";
import { NavigationVariant } from "./types";

const Navigation = ({ variant, children }: { variant: NavigationVariant; children: ReactNode }) => (
  <>
    <AppNavbar variant={variant} />
    {variant === "full" && <AppSidebar />}
    <Box
      sx={
        variant === "full"
          ? {
              paddingTop: `calc(${NAVIGATION_HEIGHT} + 32px)`,
              paddingRight: "32px",
              paddingBottom: "32px",
              paddingLeft: APP_SIDEBAR_WIDTH,
              minHeight: "100vh",
              width: "100%",
            }
          : {
              paddingTop: NAVIGATION_HEIGHT,
              minHeight: "100vh",
            }
      }
    >
      {children}
    </Box>
  </>
);

export default Navigation;
